<div class="item-category-container">

  <!-- =====================================================
       LIST VIEW
       ===================================================== -->
  <ng-container *ngIf="!hideList">

    <!-- HEADER -->
    <div class="category-toolbar">

      <div class="title-section">
        <h2 class="page-title">Item Category</h2>
        <span class="page-subtitle">
          Manage inventory categories
        </span>
      </div>

      <div class="toolbar-right">

        <!-- SEARCH -->
        <div class="search-box">
          <i class="fa fa-search"></i>

          <input
            type="text"
            placeholder="Search category..."
            [(ngModel)]="searchText"
            (input)="onSearch()" />
        </div>

        <!-- ADD -->
        <button
          type="button"
          class="btn-primary"
          (click)="openAdd()">

          <i class="fa fa-plus"></i>
          Add Category

        </button>

        <!-- DOWNLOAD -->
        <button
          type="button"
          class="icon-toolbar-btn"
          title="Download Excel"
          (click)="handleDownloadSampleExcel()">

          <img
            src="./assets/excelIcons/excel_download.svg"
            alt="Download Excel" />

        </button>

        <!-- UPLOAD -->
        <label
          class="icon-toolbar-btn"
          title="Upload Excel">

          <img
            src="./assets/excelIcons/excel_upload.svg"
            alt="Upload Excel" />

          <input
            type="file"
            hidden
            accept=".xls,.xlsx,.xlsm,.xlsb,.xlt,.xltx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            (change)="handleExcelFileUpload($event)" />

        </label>

      </div>
    </div>


    <!-- =====================================================
         META
         ===================================================== -->
    <div
      class="meta-row"
      *ngIf="!isLoading">

      <div class="page-size-wrapper">

        <span class="meta-label">
          Show
        </span>

        <select
          class="page-size"
          [(ngModel)]="pageSize">

          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>

        </select>

        <span class="meta-label">
          entries
        </span>

      </div>

      <span class="record-info">
        Total Records: <strong>{{ totalRecords }}</strong>
      </span>

    </div>


    <!-- =====================================================
         LOADING
         ===================================================== -->
    <div
      class="loading-container"
      *ngIf="isLoading">

      <div class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i>
      </div>

      <span>Loading categories...</span>

    </div>


    <!-- =====================================================
         TABLE
         ===================================================== -->
    <div
      class="table-card"
      *ngIf="!isLoading">

      <div class="table-wrapper">

        <table class="category-table">

          <thead>
            <tr>
              <th class="sr-column">Sr No.</th>
              <th>Category Name</th>
              <th>Inventory Type</th>
              <th>Storage Class</th>
              <th>Description</th>
              <th class="action-column">Action</th>
            </tr>
          </thead>

          <tbody>

            <tr
              *ngFor="let category of itemCategoryList; let i = index">

              <td class="sr-column">
                {{ ((pageNo - 1) * pageSize) + i + 1 }}
              </td>

              <td class="category-name">
                {{ category.categoryName || '-' }}
              </td>

              <td>
                <span
                  class="type-badge"
                  *ngIf="category.otherDetail1">

                  {{ category.otherDetail1 }}

                </span>

                <span
                  class="empty-value"
                  *ngIf="!category.otherDetail1">

                  -

                </span>
              </td>

              <td>
                {{ category.otherDetail2 || '-' }}
              </td>

              <td class="description-cell">
                {{ category.description || '-' }}
              </td>

              <td class="action-column">

                <div class="action-buttons">

                  <button
                    type="button"
                    class="action-btn edit-btn"
                    title="Edit"
                    (click)="openEdit(category)">

                    <i class="fa fa-pencil"></i>

                  </button>

                  <button
                    type="button"
                    class="action-btn delete-btn"
                    title="Delete"
                    (click)="confirmDelete(category)">

                    <i class="fa fa-trash"></i>

                  </button>

                </div>

              </td>

            </tr>


            <!-- EMPTY -->
            <tr
              *ngIf="itemCategoryList.length === 0">

              <td
                colspan="6"
                class="no-data">

                <div class="empty-state">

                  <i class="fa fa-folder-open"></i>

                  <strong>
                    No item categories found
                  </strong>

                  <span>
                    Add a category to get started.
                  </span>

                </div>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>


    <!-- =====================================================
         PAGINATION
         ===================================================== -->
    <div
      class="pagination-container"
      *ngIf="!isLoading && itemCategoryList.length > 0">

      <div class="pagination-info">
        Page {{ pageNo }} of {{ maxPage || 1 }}
      </div>

      <div class="pagination-buttons">

        <button
          type="button"
          class="page-btn"
          [disabled]="pageNo === 1"
          (click)="previousPage()">

          <i class="fa fa-chevron-left"></i>

        </button>

        <button
          type="button"
          class="page-btn"
          [disabled]="pageNo >= maxPage"
          (click)="nextPage()">

          <i class="fa fa-chevron-right"></i>

        </button>

      </div>

    </div>

  </ng-container>


  <!-- =====================================================
       ADD / EDIT MODAL
       ===================================================== -->
  <div
    class="category-form-overlay"
    *ngIf="showForm">

    <div class="category-form-card">

      <!-- MODAL HEADER -->
      <div class="form-header">

        <div class="form-header-text">

          <div class="form-title-row">

            <div class="form-title-icon">
              <i class="fa fa-folder"></i>
            </div>

            <div>
              <h3>
                {{ isEditMode ? 'Edit Item Category' : 'Add Item Category' }}
              </h3>

              <p>
                Define category details for inventory management.
              </p>
            </div>

          </div>

        </div>

        <button
          type="button"
          class="close-btn"
          title="Close"
          (click)="resetForm()">

          <i class="fa fa-times"></i>

        </button>

      </div>


      <!-- MODAL BODY -->
      <div class="form-body">

        <!-- ROW 1 -->
        <div class="form-row">

          <!-- CATEGORY NAME -->
          <div class="form-group">

            <label>
              Category Name
              <span class="required">*</span>
            </label>

            <input
              type="text"
              [(ngModel)]="itemCategory.categoryName"
              placeholder="e.g. Antibiotics"
              autocomplete="off" />

          </div>


          <!-- INVENTORY TYPE -->
          <div class="form-group">

            <label>
              Inventory Type
            </label>

            <select
              [(ngModel)]="itemCategory.inventoryType">

              <option value="">
                -- Select Type --
              </option>

              <option
                *ngFor="let c of inventoryTypes"
                [value]="c">

                {{ c }}

              </option>

            </select>

          </div>

        </div>


        <!-- ROW 2 -->
        <div class="form-row">

          <!-- PARENT CATEGORY -->
          <div class="form-group">

            <label>
              Parent Category
            </label>

            <select
              [(ngModel)]="itemCategory.parentCategoryId">

              <option [ngValue]="0">
                Optional
              </option>

              <option
                *ngFor="let p of getParentOptions()"
                [ngValue]="p.itemCategoryId">

                {{ p.categoryName }}

              </option>

            </select>

          </div>


          <!-- STORAGE CLASS -->
          <div class="form-group">

            <label>
              Storage Class
            </label>

            <select
              [(ngModel)]="itemCategory.storageClass">

              <option value="">
                -- Select Storage --
              </option>

              <option
                *ngFor="let s of storageClasses"
                [value]="s">

                {{ s }}

              </option>

            </select>

          </div>

        </div>


        <!-- DESCRIPTION -->
        <div class="form-group full-width">

          <label>
            Description
          </label>

          <textarea
            rows="4"
            [(ngModel)]="itemCategory.description"
            placeholder="Enter category description...">
          </textarea>

        </div>


        <!-- ACTIONS -->
        <div class="form-actions">

          <button
            type="button"
            class="btn-cancel"
            (click)="resetForm()">

            Cancel

          </button>

          <button
            type="button"
            class="btn-save"
            (click)="saveItemCategory()"
            [disabled]="!isFormValid()">

            <i
              class="fa"
              [ngClass]="isEditMode ? 'fa-save' : 'fa-plus'">
            </i>

            {{ isEditMode ? 'Update Category' : 'Save Category' }}

          </button>

        </div>

      </div>

    </div>

  </div>


  <!-- =====================================================
       DELETE CONFIRMATION
       ===================================================== -->
  <div
    class="delete-overlay"
    *ngIf="showDeleteConfirmation">

    <div class="delete-card">

      <div class="delete-icon">
        <i class="fa fa-trash"></i>
      </div>

      <h3>
        Delete Item Category?
      </h3>

      <p>
        Are you sure you want to delete this item category?
      </p>

      <div class="delete-actions">

        <button
          type="button"
          class="btn-cancel"
          (click)="cancelDelete()">

          Cancel

        </button>

        <button
          type="button"
          class="btn-danger"
          (click)="deleteItemCategory(deleteItemCategoryId)">

          <i class="fa fa-trash"></i>
          Delete

        </button>

      </div>

    </div>

  </div>

</div>